// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__2fM8O","control":"Checkout_control__2eyIy","actions":"Checkout_actions__2Hi0P","submit":"Checkout_submit__1ce-s","invalid":"Checkout_invalid__3-UGa"};